import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { StaticPage } from './StaticPage';

/**
 * Yardım — Sürüm Notları / Gizlilik / Kurallar. Legacy `Home/{Releases,Privacy,Rules}`.
 * İçerik client-side statik (bkz. helpContent.tsx) — `Content/GetStaticPage` API'de yok.
 * Legacy `Home/HesCode` (COVID dönemi HES kodu) çıkarıldı.
 */
export const helpModule: ModuleDefinition = {
  routes: [
    { path: 'help/releases', element: <StaticPage pageKey="releases" /> },
    { path: 'help/privacy', element: <StaticPage pageKey="privacy" /> },
    { path: 'help/rules', element: <StaticPage pageKey="rules" /> },
  ],
  menuItems: [
    { label: 'Sürüm Notları', path: 'help/releases', icon: <NewReleasesOutlinedIcon />, group: 'Yardım', groupIcon: <HelpOutlineOutlinedIcon /> },
    { label: 'Gizlilik', path: 'help/privacy', icon: <PrivacyTipOutlinedIcon />, group: 'Yardım' },
    { label: 'Kurallar', path: 'help/rules', icon: <GavelOutlinedIcon />, group: 'Yardım' },
  ],
};
